<template>
    <div class="container-fluid" style="background-color: #f0f0f0;">
    <div class="contact-block text-center">
      <div class="form-container">
        <div class="form-header">
          <div class="block_title text-center">{{ $t('newsletter.title') }}</div>
          <p class="form-subtitle">{{ $t('newsletter.content') }}</p>
        </div>
        <div class="form-body">
          <div id="hubspot-form-container"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    name: 'MailjetNewsLetter',
    data(){
      return {
      }
    },
    mounted() {
        // Create and load HubSpot form
        const script = document.createElement('script');
        script.charset = 'utf-8';
        script.type = 'text/javascript';
        script.src = '//js.hsforms.net/forms/embed/v2.js';
        script.onload = () => {
            window.hbspt.forms.create({
                portalId: "8691471",
                formId: "7a15ef98-8ada-4a16-9b66-6187ebeece49",
                region: "na1",
                target: "#hubspot-form-container",
                css: ""
            });
        };
        document.head.appendChild(script);
        
        // Add custom styles for Hubspot form
        const styleEl = document.createElement('style');
        styleEl.innerHTML = `
          .hs-form-field > label {
            font-weight: 500;
            margin-bottom: 8px;
            margin-top: 10px;
            color: #333;
            width: 100% !important;
          }
          .hs-form input[type="text"], .hs-form input[type="email"], .hs-form input[type="tel"], .hs-form textarea, .hs-form select {
            width: 100% !important;
            padding: 12px 15px !important;
            border: 1px solid #e0e0e0 !important;
            border-radius: 4px !important;
            transition: border-color 0.3s ease !important;
            background-color: #fff !important;
            font-size: 14px !important;
          }
          .hs-form input[type="text"]:focus, .hs-form input[type="email"]:focus, .hs-form input[type="tel"]:focus, .hs-form textarea:focus, .hs-form select:focus {
            border-color: var(--mainGreen) !important;
            outline: none !important;
            box-shadow: 0 0 0 2px rgba(33, 227, 159, 0.2) !important;
          }
          .hs-button {
            background-color: var(--mainGreen) !important;
            color: white !important;
            padding: 12px 25px !important;
            border-radius: 4px !important;
            border: none !important;
            font-weight: 600 !important;
            font-size: 16px !important;
            cursor: pointer !important;
            transition: background-color 0.3s ease !important;
            text-transform: uppercase !important;
          }
          .hs-button:hover {
            background-color: var(--mainBlue) !important;
          }
        .hs-field-desc{
            font-size: 14px !important;
            width: 100% !important;
            text-align: left !important;
        }
        
        .hs-form-field ul {
          list-style-type: none !important;
          padding-left: 0 !important;
          margin-left: 0 !important;
        }
        
        .hs-form-field ul li {
          list-style: none !important;
        }
        `;
        document.head.appendChild(styleEl);
    }
}
</script>


<style lang="scss" scoped>
.contact-block {
  color: #333;
  font-weight: 400;
  font-size: 15px;
//   background-color: white;
  padding: 40px 20px;
  border-radius: 8px;
  text-align: center;
  margin-bottom: 100px;
//   box-shadow: 0 5px 20px rgba(0, 0, 0, 0.05);
}

.form-container {
  max-width: 800px;
  margin: 0 auto;
}

.form-header {
  margin-bottom: 30px;
}

.block_title {
  color: var(--mainBlue);
  font-weight: 700;
  font-size: 32px;
  padding-bottom: 15px;
  position: relative;
}

.block_title:after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 50px;
  height: 3px;
  background-color: var(--mainGreen);
}

.form-subtitle {
  font-size: 16px;
  color: #666;
  margin-top: 20px;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
}

.form-body {
  background-color: #f9f9f9;
  border-radius: 6px;
  padding: 30px;
}
</style>